module.exports = function () {
  var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var html = "\n    <div class=\"deck deck-overlay hide-scrollbar\">\n    </div>\n  ";
  return html;
};